import { transport } from 'config/transport';

export function callApiDeleteDuThu(congDoanId, gradeId, duThuId) {
    return transport.del(`/mamnon/${congDoanId}/thuhocsinh/${gradeId}/duthu/${duThuId}`);
}
